import { AdminListSubMenu } from './constants';
import BinIcon from '../components/CustomIcons/BinIcon';
import MenuData from '../types/ui/menu-data';
import React from 'react';
import ReloadIcon from '../components/CustomIcons/ReloadIcon';
import { t } from 'i18next';

export const ADMIN_SUB_MENU_LIST: Array<MenuData> = [
	{
		id: AdminListSubMenu.ResendInvite,
		value: t('resendInvite'),
		icon: <ReloadIcon />
	},
	{
		id: AdminListSubMenu.Delete,
		value: t('delete'),
		icon: <BinIcon />,
		isDestructive: true
	}
];